(function() {
    'use strict';
    angular.module('Services').service('TransitWarrantyReportedClaimsTableService', TransitWarrantyReportedClaimsTableService);
    TransitWarrantyReportedClaimsTableService.$inject = [
        'TableLiteFactory',
        '$filter'
    ];

    function TransitWarrantyReportedClaimsTableService(
        TableLiteFactory,
        $filter
    ) {
        return function (reportData) {
            const tableStructure = {
                tableName: 'TransitWarrantyReportedClaimsTableService',
                config: {
                    noPagination: true,
                    noFooter: true
                },
                headers: [
                    {
                        label: 'Created Date',
                        viewName: 'createdDate'
                    },
                    {
                        label: 'Reference Number',
                        viewName: 'referenceNumber'
                    },
                    {
                        label: 'Consignment Number',
                        viewName: 'consignmentNumber'
                    },
                    {
                        label: 'Carrier Profile',
                        viewName: 'carrierProfileName'
                    },
                    {
                        label: 'Customer Name',
                        viewName: 'customerName'
                    },
                    {
                        label: 'Declared Value',
                        viewName: 'declaredValue'
                    },
                    {
                        label: 'Claimed Amount',
                        viewName: 'claimAmount'
                    }
                ],
                data: []
            }
            const tableActions = new TableLiteFactory(tableStructure, {
                serviceCallback: function(callback) {
                    callback({content: reportData})
                },
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data)
                },
                postRequestErrorCallback: data => {
                    buildTableData(null);
                },
                defaultFilters: {}
            });

            function buildTableData(data) {
                if (!data) {
                    return tableStructure;
                }

                tableActions.initializeTableData(data);
                angular.forEach(data.content, row => {
                    row.createdDate = $filter('bbaDate')(row.createdDate);
                    tableStructure.data.push(row);
                });
            }

            function toggleLoadingIndicator(isLoading) {
                tableStructure.isFetching = isLoading;
            }

            function updateTableData (reportData) {
                tableStructure.data = [];
                buildTableData({content: reportData});
            }

            function totalClaimAmount () {
                let total = 0; 
                tableStructure.data.forEach(item => { total += item.claimAmount; });
                return angular.toFixedNoRounding(total, 2);
            }

            this.toggleLoadingIndicator = toggleLoadingIndicator;
            this.updateTableData = updateTableData;
            this.totalClaimAmount = totalClaimAmount;
            this.tableData = tableStructure;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/transit-warranty/TransitWarrantyReportedClaimsTableService.js